import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPreorders } from '../actions/PreorderActions';
import DataTable from '../../common/DataTable/DataTable';
import { Link } from 'react-router-dom';
import { Button, Pane } from 'evergreen-ui';

class ListPreorders extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getPreorders(opts));
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/preorders/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Precomanda noua
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    {id: 'id', label: 'Id'},
                    {id: 'productId', label: 'Produs'},
                    {id: 'quantity', label: 'Quantity'},
                    {id: 'quantityAvailable', label: 'Quantity Available'},
                    {id: 'createdAt', label: 'Creat', decorator: 'date'},
                    {id: 'updatedAt', label: 'Modificat', decorator: 'date'}
                ]}

                data={this.props.data}

                onTableChange={this.handleTableChange}

                itemMenu={[
                    { getLink: (item) => `/preorders/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/preorders/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.preorders;
}

export default connect(mapStateToProps)(ListPreorders);